export enum WhitelabelSubjectApplication {
  PLATFORM = 'PLATFORM',
  DBS = 'DBS',
  IDENTITY = 'IDENTITY',
}

export enum AgencyDnsSettingStatus {
  LEGACY = 'LEGACY',
  PENDING = 'PENDING',
  /** Deletion started; the backend removes the row once CloudFront has caught up. */
  PENDING_DELETION = 'PENDING_DELETION',
  CONNECTED = 'CONNECTED',
  ERROR = 'ERROR',
}

export interface ApplicationDnsSetting {
  application: WhitelabelSubjectApplication;
  domain: string;
  cnameTarget: string | null;
  status: AgencyDnsSettingStatus;
}

export interface GetAgencyDnsSettingsResponse {
  applicationSettings: ApplicationDnsSetting[];
}

export interface CreateAgencyDnsSettingResponse {
  dnsSettings: ApplicationDnsSetting;
}

export interface CreateAgencyDnsSettingPayload {
  domain: string;
  application: WhitelabelSubjectApplication;
}

export interface DeleteAgencyDnsSettingPayload {
  domain: string;
  application: WhitelabelSubjectApplication;
}

export interface CustomDomainFormValues {
  domain: string;
  /** Read-only, provisioned by the backend; displayed for copy purposes only. */
  cnameTarget: string;
}
